if (!customElements.get('product-addons')) {
  customElements.define('product-addons', class ProductAddons extends HTMLElement {
    constructor() {
      super();
      this.checkboxes = this.querySelectorAll('.product-addons__checkbox');
      this.paymentButtonWrapper = this.closest('product-info')?.querySelector('.shopify-payment-button');
    }

    connectedCallback() {
      this.status = document.createElement('span');
      this.status.className = 'product-addons__button-status visually-hidden';
      this.status.setAttribute('aria-live', 'polite');
      this.append(this.status);

      this.createCustomBuyButton();

      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', this.togglePaymentButton.bind(this));
      });
      this.togglePaymentButton(); 
    }

    createCustomBuyButton() {
      if (!this.paymentButtonWrapper) return;
      
      this.customBuyButton = document.createElement('button');
      this.customBuyButton.type = 'button';
      this.customBuyButton.className = 'shopify-payment-button__button shopify-payment-button__button--unbranded';
      this.customBuyButton.textContent = 'Buy it now';
      this.customBuyButton.style.display = 'none';
      
      this.customBuyButton.addEventListener('click', (e) => this.handleCustomBuyNow(e));
      
      this.paymentButtonWrapper.parentNode.insertBefore(this.customBuyButton, this.paymentButtonWrapper.nextSibling);
    }

    togglePaymentButton() {
      if (!this.paymentButtonWrapper || !this.customBuyButton) return;
      
      if (this.hasSelectedAddons()) {
        this.paymentButtonWrapper.style.display = 'none';
        this.customBuyButton.style.display = 'block';
      } else {
        this.paymentButtonWrapper.style.display = '';
        this.customBuyButton.style.display = 'none';
      }
    }

    hasSelectedAddons() {
      // Ensure we only count actual add-ons, ignoring the dummy main product checkbox
      return Array.from(this.checkboxes).some(checkbox => checkbox.checked && checkbox.dataset.addonId);
    }

    async handleCustomBuyNow(event) {
      event.preventDefault();
      
      const form = this.closest('product-info')?.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      const mainVariantId = form.querySelector('[name="id"]')?.value;
      if (!mainVariantId) return;

      const quantity = Number(form.querySelector('[name="quantity"]')?.value) || 1;
      
      const items = [{ id: Number(mainVariantId), quantity }];
      
      this.querySelectorAll('.product-addons__checkbox:checked').forEach((input) => {
        // Exclude the dummy checkbox by checking for a valid dataset ID
        if (input.dataset.addonId) {
          items.push({ id: Number(input.dataset.addonId), quantity: 1 });
        }
      });

      this.customBuyButton.setAttribute('aria-disabled', true);
      this.customBuyButton.classList.add('loading');
      this.customBuyButton.textContent = 'Redirecting...';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || 'Unable to checkout bundle.');
        }
        
        window.location.href = '/checkout';

      } catch (error) {
        this.status.textContent = error.message;
        console.error("Buy Now Error:", error);
        
        this.customBuyButton.removeAttribute('aria-disabled');
        this.customBuyButton.classList.remove('loading');
        this.customBuyButton.textContent = 'Buy it now';
      }
    }

    async addSelectedAddons(form) {
      const submitButton = form.querySelector('[type="submit"]');
      const items = [];
      
      this.querySelectorAll('.product-addons__checkbox:checked').forEach((input) => {
        // Exclude the dummy checkbox by checking for a valid dataset ID
        if (input.dataset.addonId) {
          items.push({ id: Number(input.dataset.addonId), quantity: 1 });
        }
      });

      if (items.length === 0) return;

      this.status.textContent = 'Adding…';
      
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      }

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || 'Unable to add the bundle.');
        }
        
        form.dataset.addonsAdded = 'true';
        if (submitButton) {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
        }
        
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitButton);
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }

      } catch (error) {
        this.status.textContent = error.message;
        console.error("Cart Add Error:", error);
        if (submitButton) {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
        }
      }
    }
  });
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;

  if (form.dataset.addonsAdded === 'true') {
    form.dataset.addonsAdded = 'false';
    return; 
  }

  const addons = form.closest('product-info')?.querySelector('product-addons');
  if (!addons?.hasSelectedAddons()) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  
  addons.addSelectedAddons(form);
}, true);